import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';

@Component({
  selector: 'app-selfie-payment',
  templateUrl: './selfie-payment.component.html',
  styleUrls: ['./selfie-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelfiePaymentComponent implements OnInit {

  constructor(public nav: NavigateService, private cart: CartService) { }

  ngOnInit(): void {
    this.cart.selfiePerson = undefined;
    this.cart.state = 'selfie';
  }

  backClick() {
    this.nav.to('people');
  }
}
